import { render, staticRenderFns } from "./DealerStatus.vue?vue&type=template&id=1af1cfe0&scoped=true&"
import script from "./DealerStatus.vue?vue&type=script&lang=js&"
export * from "./DealerStatus.vue?vue&type=script&lang=js&"
import style0 from "./DealerStatus.vue?vue&type=style&index=0&id=1af1cfe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1cfe0",
  null
  
)

export default component.exports